export const SUCCEEDED = '#4fe9be'
export const SILVER = '#d1d1d6'
export const DARK_GREY_BLUE = '#365271'
export const DARK_BLUE_GREY = '#283845'
